var map = {
	"./2024-mothers-day/au/desktop_2x.jpg": 96779,
	"./2024-mothers-day/na/desktop_2x.jpg": 45316,
	"./fathersday/desktop_2x.jpg": 92715,
	"./generic/desktop_2x.jpg": 61803,
	"./holiday/desktop_2x.jpg": 61834,
	"./mothersday/au/desktop_2x.jpg": 19179,
	"./mothersday/desktop_2x.jpg": 60854,
	"./mothersday/na/desktop_2x.jpg": 67716,
	"./valentines/desktop_2x.jpg": 22275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99919;